import styled from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const HeadlineContent = styled.h2`
    padding-bottom: 2rem;
    word-break: break-word;

    ${FONT_PROPERTIES}

    ${mediaMaxWidth.medium`
        padding-bottom: 1.5rem;
    `}

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;
